export interface UseLiquidationQuantityMessageProps {
    liquidationValue?: string | null;
    requestedQty?: number | null;
    availableQty?: number | null;
}

export interface UseLiquidationQuantityMessageResult {
    availableQty: number;
    /** @deprecated Use isLiquidation instead. We no longer want to check quantity > availableQty to display availableQty */
    exceedsAvailableQty: boolean;
    isLiquidation: boolean;
    showAvailableQtyMessage: boolean;
}

export default function useLiquidationQuantityMessage({
    liquidationValue,
    requestedQty,
    availableQty,
}: UseLiquidationQuantityMessageProps): UseLiquidationQuantityMessageResult {
    const normalizedAvailableQty = Number.isFinite(availableQty) ? Number(availableQty) : 0;
    const normalizedRequestedQty = Number.isFinite(requestedQty) ? Number(requestedQty) : 0;
    const isLiquidation = Boolean(liquidationValue?.trim());
    const hasQuantity = availableQty !== undefined && availableQty !== null;
    const showAvailableQtyMessage = isLiquidation && hasQuantity && normalizedRequestedQty > normalizedAvailableQty;

    return {
        availableQty: normalizedAvailableQty,
        exceedsAvailableQty: showAvailableQtyMessage,
        isLiquidation,
        showAvailableQtyMessage,
    };
}